/**
 * HOME-BUTTON
 * Small square button for home page sections
 */

import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Card from "./card"

interface Props {
  icon: IconDefinition
  imageAsCta?: string | null
  preTitle?: string
  title: string
  onClick: () => void
}

function HomeButtonTitle({ preTitle, title }: { preTitle?: string; title: string }) {
  return (
    <div className="leading-none">
      {preTitle && <div className="text-sm leading-none opacity-70">{preTitle}</div>}
      <div className="mt-2 text-lg leading-[1.20]">{title}</div>
    </div>
  )
}

export default function HomeButton({ icon, imageAsCta, onClick, preTitle, title }: Props) {
  const bgUrl = imageAsCta ? require(`@/assets/${imageAsCta}.png`) : null
  const isImageCta = Boolean(imageAsCta)

  return (
    <Card
      isWithoutPadding
      onClick={onClick}
      className={`group relative mb-0 flex-1 overflow-hidden _hover ${isImageCta ? "text-white" : ""}`}
      style={{
        border: "1px solid #0E5AA7",
        backgroundColor: isImageCta ? "#2664A8" : undefined,
        height: 106,
        minWidth: isImageCta ? 180 : 120
      }}>
      {bgUrl && (
        <div
          className="absolute inset-0 bg-cover transition-transform duration-300 group-hover:scale-[1.02]"
          style={{
            backgroundImage: `url(${bgUrl})`,
            backgroundPosition: "100% top",
            backgroundSize: "120%"
          }}
        />
      )}
      <div className="relative z-10 flex h-[86px] flex-col p-10">
        <div className="flex h-[34px] w-[34px] items-center justify-center rounded-[12px] bg-[#EAF2FB] text-[#0E5AA7]">
          <FontAwesomeIcon icon={icon} className="text-[15px]" />
        </div>
        <div className="flex-1" />
        <HomeButtonTitle preTitle={preTitle} title={title} />
      </div>
    </Card>
  )
}
